<script lang="ts">
    import {ZodError} from "zod";
    import InputNumber from "../../shared/InputNumber.svelte";

    export let label: string = '';
    export let annotation: string = '';
    export let value: number = 0;
    export let step: string = '1';
    export let update: () => void;
    export let validator: (data: unknown) => { success: true; data: number; } | { success: false; error: ZodError; }

    let error: string = '';
    let success: boolean = false;

    function swoop() {
        return {
            duration: 1000,
            css: () => `transform: scale(.5)`
        }
    }

</script>

<div class="settings-group" class:error={error!==''}>
    <div class="settings-label">{label}</div>
    <div>
        <div style="display:flex; flex-direction: row; align-items: center; column-gap: 4px;">
            <!--            <input class="settings-value" type="number" min="0" max="60"-->
            <!--                   value={value}-->
            <InputNumber
                value={value}
                {step}
                width="100%"
                on:change={
                        (event) => {
                            const newValue = event.target?.value;
                            let result = validator(newValue);
                            if (result.success) {
                                error = '';
                                value = result.data;
                                success = true;
                                update();
                            } else {
                                error = result.error.issues[0].message;
                                success = false;
                            }
                        }
               }
            />
            <div>{annotation}</div>
        </div>
        {#if error!==''}
            <div class="error-message">{error}</div>
        {/if}
    </div>
</div>

<style>
    .settings-group {
        display: flex;
        align-items: center;
        column-gap: 10px;
        justify-content: flex-start;
        min-height: 33px;
        font-size: 14px;
        border-radius: 6px;
        margin-bottom: 3px;
        padding: 3px 6px;
    }
    .settings-label {
        flex: 0.1 1 100px;
        /*min-width: 120px;*/
        /*white-space: nowrap;*/
    }
    .settings-value {
        flex: 0 0 60px;
        box-sizing: border-box;
        width: 100%;
        /*padding: 3px 6px;*/
        margin: 0 3px;
        background-color: #ffffff;
        border: 0;
        /*border-radius: 4px;*/
        padding: var(--input-small-padding);
        border: var(--input-small-border);
        border-radius: var(--input-small-border-radius);
        color: var(--input-small-color);
    }
    .error {
        /*background-color: var(--automapa-red);*/
        border: 2px solid var(--automapa-red);
    }
    .success {
        /*border: 2px solid var(--automapa-green);*/
        /*background-color: var(--automapa-green);*/
        background-color: transparent;
        animation: success-blink 0.5s;
    }
    @keyframes success-blink {
        0% {
            background-color: transparent;
        }
        50% {
            background-color: var(--automapa-green);
        }
        100% {
            background-color: transparent;
        }
    }
    .error-message {
        margin-top: 3px;
    }
</style>
